// fleet category
const warehouseList = state => state.warehouseList
const isLoadingWarehouseList = state => state.isLoadingWarehouseList
const errorWarehouseList = state => state.errorWarehouseList

const postDraft = state => state.postDraft
const isLoadingPostDraft = state => state.isLoadingPostDraft
const errorPostDraft = state => state.errorPostDraft

const postSubmit = state => state.postSubmit
const isLoadingPostSubmit = state => state.isLoadingPostSubmit
const errorPostSubmit = state => state.errorPostSubmit

const inboundList = state => state.inboundList.data
const isLoadingInboundList = state => state.isLoadingInboundList
const errorInboundList = state => state.errorInboundList

const inboundDetail = state => state.inboundDetail
const isLoadingInboundDetail = state => state.isLoadingInboundDetail
const errorInboundDetail = state => state.errorInboundDetail

const cancelInbound = state => state.cancelInbound.data
const isLoadingCancelInbound = state => state.isLoadingCancelInbound
const errorCancelInbound = state => state.errorCancelInbound

const editSKU = state => state.editSKU.data
const isLoadingEditSKU = state => state.isLoadingEditSKU
const errorEditSKU = state => state.errorEditSKU

const inboundDocument = state => state.inboundDocument
const isLoadingInboundDocument = state => state.isLoadingInboundDocument
const errorInboundDocument = state => state.errorInboundDocument

const inboundHistory = state => state.inboundHistory
const isLoadingInboundHistory = state => state.isLoadingInboundHistory
const errorInboundHistory = state => state.errorInboundHistory

const inventoryList = state => state.inventoryList.data
const isLoadingInventoryList = state => state.isLoadingInventoryList
const errorInventoryList = state => state.errorInventoryList

const inventoryDetail = state => state.inventoryDetail
const isLoadingInventoryDetail = state => state.isLoadingInventoryDetail
const errorInventoryDetail = state => state.errorInventoryDetail

const inventoryHistory = state => state.inventoryHistory
const isLoadingInventoryHistory = state => state.isLoadingInventoryHistory
const errorInventoryHistory = state => state.errorInventoryHistory

const downloadSku = state => state.downloadSku
const isLoadingDownloadSku = state => state.isLoadingDownloadSku
const errorDownloadSku = state => state.errorDownloadSku

const moveInventory = state => state.moveInventory
const isLoadingMoveInventory = state => state.isLoadingMoveInventory
const errorMoveInventory = state => state.errorMoveInventory

const downloadFileInventory = state => state.downloadFileInventory
const isLoadingDownloadFileInventory = state =>
  state.isLoadingDownloadFileInventory
const errorDownloadFileInventory = state => state.errorDownloadFileInventory

const multipleSkuUpload = state => state.multipleSkuUpload
const isLoadingMultipleSkuUpload = state => state.isLoadingMultipleSkuUpload
const errorMultipleSkuUpload = state => state.errorMultipleSkuUpload

const supportingDocumentUpload = state => state.supportingDocumentUpload
const isLoadingSupportingDocumentUpload = state =>
  state.isLoadingSupportingDocumentUpload
const errorSupportingDocumentUpload = state =>
  state.errorSupportingDocumentUpload

const downloadOutStorageReport = state => state.downloadOutStorageReport
const isLoadingDownloadOutStorageReport = state =>
  state.isLoadingDownloadOutStorageReport
const errorDownloadOutStorageReport = state =>
  state.errorDownloadOutStorageReport

export default {
  warehouseList,
  isLoadingWarehouseList,
  errorWarehouseList,

  postDraft,
  isLoadingPostDraft,
  errorPostDraft,

  postSubmit,
  isLoadingPostSubmit,
  errorPostSubmit,

  inboundList,
  isLoadingInboundList,
  errorInboundList,

  inboundDetail,
  isLoadingInboundDetail,
  errorInboundDetail,

  cancelInbound,
  isLoadingCancelInbound,
  errorCancelInbound,

  editSKU,
  isLoadingEditSKU,
  errorEditSKU,

  inboundDocument,
  isLoadingInboundDocument,
  errorInboundDocument,

  inboundHistory,
  isLoadingInboundHistory,
  errorInboundHistory,

  inventoryList,
  isLoadingInventoryList,
  errorInventoryList,

  inventoryDetail,
  isLoadingInventoryDetail,
  errorInventoryDetail,

  inventoryHistory,
  isLoadingInventoryHistory,
  errorInventoryHistory,

  downloadSku,
  isLoadingDownloadSku,
  errorDownloadSku,

  moveInventory,
  isLoadingMoveInventory,
  errorMoveInventory,

  downloadFileInventory,
  isLoadingDownloadFileInventory,
  errorDownloadFileInventory,

  multipleSkuUpload,
  isLoadingMultipleSkuUpload,
  errorMultipleSkuUpload,

  supportingDocumentUpload,
  isLoadingSupportingDocumentUpload,
  errorSupportingDocumentUpload,

  downloadOutStorageReport,
  isLoadingDownloadOutStorageReport,
  errorDownloadOutStorageReport
}



// WEBPACK FOOTER //
// ./src/store/modules/warehouse/getters.js